import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './carousel-article-list-item.component.scss';
var CarouselArticleListItem = /** @class */ (function (_super) {
    tslib_1.__extends(CarouselArticleListItem, _super);
    function CarouselArticleListItem(element) {
        return _super.call(this, element) || this;
    }
    CarouselArticleListItem.prototype.init = function () { };
    ;
    CarouselArticleListItem.prototype.bindEvents = function () { };
    ;
    return CarouselArticleListItem;
}(Base));
export { CarouselArticleListItem };



//////////////////
// WEBPACK FOOTER
// ./components/carousel-article-list-item/carousel-article-list-item.component.ts
// module id = 183
// module chunks = 0